import type { ReactNode } from 'react'
import type { NavLink } from './types'
import React, { useState } from 'react'
import SecondaryNavContext from './SecondaryNavContext'

interface SecondaryNavProviderProps {
  children: ReactNode
}

// Links are set and cleared by their owner through useSecondaryNav.
export function SecondaryNavProvider({ children }: SecondaryNavProviderProps) {
  const [links, setLinks] = useState<NavLink[]>([])

  return (
    <SecondaryNavContext.Provider value={{ links, setLinks }}>
      {children}
    </SecondaryNavContext.Provider>
  )
}
